<div class="modal__content filter--popup">
  <div class="modal-header">
    <h3 class="popup__title">Filter by</h3>
    <button class="popup__close" (click)="onClose()">
      <div [innerHTML]="ICONS.closeCircleIcon | safeHtml"></div>
    </button>
  </div>
  <div class="modal-body popup__body">
    <div class="popup__tabs">
      <button
        class="popup__tab"
        data-tab="status"
        *ngFor="let filterType of filtersList; let i = index"
        [class.popup__tab--active]="i == selectedFilterIndex"
        (click)="selectedFilterIndex = i"
      >
        {{ filterType.name }}
      </button>
    </div>
    <!-- Status Tab Content -->
    <div class="tab-content">
      <div class="content__search-bar" *ngIf="filtersList[selectedFilterIndex].name == 'Sports'">
        <!-- <img src="../../../../assets/images/ic_search.svg" alt="ic_search" class="search-bar__icon" /> -->
        <div class="search-bar__icon" [innerHTML]="ICONS.searchIcon | safeHtml"></div>
        <input
          type="text"
          class="search-bar__input"
          placeholder="Search"
          (keyup)="onSearchUser(false, filtersList[selectedFilterIndex].name)"
          (keyup.enter)="onSearchUser(true, filtersList[selectedFilterIndex].name)"
          [(ngModel)]="searchContent"
        />
      </div>
      <div
        class="popup__tab-content popup__tab-content--active"
        id="status"
        [scrollWindow]="false"
        infiniteScroll
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="300"
        (scrolled)="onScroll($event, filtersList[selectedFilterIndex].name)"
      >
        <div
          class="popup__radio-group"
          *ngFor="let filter of filtersList[selectedFilterIndex].children"
          [class.dateRange]="filtersList[selectedFilterIndex].type == 'dateRange'"
        >
          @if (filtersList[selectedFilterIndex].type == 'PriceRange') {
            <div class="form-group col-12 dateBox">
              <ngx-slider [(value)]="value" [(highValue)]="highValue" [options]="options" (valueChange)="valueChange()"></ngx-slider>
            </div>
            <div class="mt-4 ptRange">
              <span class="point">{{ value }} points</span>
              <span>to</span>
              <span class="point">{{ highValue }} points</span>
            </div>
          } @else if (filtersList[selectedFilterIndex].type == 'dateRange') {
            <div class="form-group col-12 dateBox">
              <label>{{ filter.name }}:</label>
              <input
                type="text"
                class="datepicker date datepickericon form__input form-control"
                [(ngModel)]="selectedDateFilters[filter.id]"
                placeholder="{{ filter.name }}"
                bsDatepicker
                readonly
                [minDate]="filter.id == 'from' ? null : selectedDateFilters.from"
                [maxDate]="today"
                [disabled]="filter.id == 'from' ? false : !selectedDateFilters.from ? true : false"
                (ngModelChange)="onChangeDate(filter.id)"
                (keydown)="disableKeyPress($event)"
                [bsConfig]="{ customTodayClass: 'today', dateInputFormat: 'DD-MM-YYYY', showWeekNumbers: false }"
              />
            </div>
          } @else if (filtersList[selectedFilterIndex].type == 'checkbox') {
            <label class="popup__checkbox-option">
              <input
                type="checkbox"
                name="status"
                class="popup__checkbox"
                value="{{ filter.id }}"
                (change)="onSelectFilter(filter)"
                [checked]="selectedFilters != undefined && selectedFilters?.indexOf(filter.id) != -1 ? true : false"
              />
              {{ filter.name }}
            </label>
          } @else {
            <label class="popup__radio-option">
              <input
                type="radio"
                class="popup__radio"
                (change)="onSelectRadioFilter(filter)"
                name="example-checkbox1"
                value="{{ filter.sId }}"
                [checked]="selectedFiltersRadio != undefined && selectedFiltersRadio?.indexOf(filter.id) != -1 ? true : false"
              />
              {{ filter.name }}
            </label>
          }
        </div>
        <div class="searchResult" *ngIf="filtersList[selectedFilterIndex].children.length == 0">
          <div class="searching text-center">
            <h5>No record found!</h5>
          </div>
        </div>
      </div>
      <div class="popup__footer">
        <button class="popup__button popup__clear" (click)="onClearAll()">Clear all</button>
        <button class="popup__button popup__apply" [disabled]="compareArrays()" (click)="onApply()">Apply</button>
      </div>
    </div>
  </div>
</div>
